import {
    EscalationInfo,
    OnbardingWebviewInfo,
    GenerateOnboardingCookieRequest,
    GenerateOnboardingCookieRequestOpen,
} from '../models/Escalation';
import ApisClient from '../utils/client/ApisClient';
import TokenHandlerClient from '../utils/client/TokenHandlerClient';

export const getCustomerScopes = () => {
    return ApisClient.get<string[]>('/escalation/scopes');
};

export const getEscalationInfo = () => {
    return ApisClient.get<EscalationInfo>('/escalation/info');
};

export const getOnboardingNoClient = (signalingId: string, redirectUri: string, state: string, error?: string) => {
    return TokenHandlerClient.get('/escalation/onboarding/prospect', {
        params: {
            signalingId,
            redirectUri,
            state,
            error,
        },
    });
};

export const generateOnboardigCookieNoClient = (data: GenerateOnboardingCookieRequestOpen) => {
    return TokenHandlerClient.post('/onboarding/prospect', data);
};

// Closed OBD
// V1

export const getOnboardingWebview = (redirectUri: string, state: string) => {
    return ApisClient.get<OnbardingWebviewInfo>(`/escalation/onboarding?redirectUri=${redirectUri}&state=${state}`);
};

export const generateOnBoardingCookie = (data: GenerateOnboardingCookieRequest) => {
    return TokenHandlerClient.post('/onboarding', data);
};

// V2

export const getOnboardingWebview2 = (redirectUri: string, state: string) => {
    return ApisClient.get<OnbardingWebviewInfo>(`/escalation/onboarding/v2?redirectUri=${redirectUri}&state=${state}`);
};

export const generateOnBoardingCookie2 = (data: GenerateOnboardingCookieRequest) => {
    return TokenHandlerClient.post('/onboarding/v2', data);
};

export const sendEscalationOTP = (contact: string, action: string) => {
    return ApisClient.post('/escalation/otp/send', { contact, action });
};

export const generateOtpCookie = (otp: string) => {
    return TokenHandlerClient.post('/otp', { otp });
};
